<template>
  <div>
    <div class="template-item">
      <div class="w1200">
        <div class="home-item-title">
          <div
            style="
              font-weight: 700;
              font-size: 50px;
              color: #1d2129;
              line-height: 50px;
            "
          >
            CLoud模板中心
          </div>
          <div
            style="
              font-size: 24px;
              color: #333333;
              line-height: 40px;
              margin-top: 30px;
              width: 436px;
            "
          >
            内置上百套官方应用，精准契合多业务场景， 按需启用，助您高效启航。
          </div>
          <div
            style="
              width: 168px;
              height: 48px;
              background: #2e98fe;
              border-radius: 6px;
              margin-top: 40px;
              color: #fff;
              gap: 12px;
              font-weight: 500;
              font-size: 20px;
              line-height: 48px;
            "
            class="center hover-btn"
          >
            <span>免费使用</span><i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
      <img
        src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/26/头图@2x (2)-183102810.png"
        alt=""
      />
    </div>
    <div class="w1200" style="padding: 40px 0">
      <div class="center" style="justify-content: left; gap: 10px">
        <svg-icon
          icon-class="icon_hot"
          style="width: 22px; height: 29px"
        ></svg-icon>
        <span
          style="
            font-size: 24px;
            color: #1d2129;
            line-height: 40px;
            text-align: left;
          "
          >热门推荐</span
        >
      </div>

      <div class="template-list between">
        <div
          class="template-list-item between"
          v-for="item in hotList"
          :key="item.title"
        >
          <div class="template-list-item-title">
            <span>{{ item.title }}</span>
            <span>{{ item.desc }}</span>
          </div>
          <div class="template-list-item-img">
            <img :src="item.img" alt="" />
          </div>
        </div>
      </div>
    </div>

    <div class="navs-filter">
      <div class="navs-filter-list w1200">
        <div class="center" style="gap: 24px; height: 100%">
          <div
            class="navs-filter-list-item"
            :class="{ active: activeFilter === '全部场景' }"
            @click="activeFilter = '全部场景'"
          >
            全部场景
          </div>
          <div
            class="navs-filter-list-item"
            v-for="(item, index) in filterList"
            :key="index"
            :class="{ active: activeFilter === item.title }"
            @click="activeFilter = item.title"
          >
            {{ item.title }}
          </div>
        </div>

        <div class="navs-filter-search">
          <el-input
            v-model="searchValue"
            placeholder="输入关键词搜索"
            clearable
          ></el-input>
          <div
            style="
              width: 40px;
              height: 32px;
              background: #2e98fe;
              border-radius: 0px 4px 4px 0px;
              cursor: pointer;
            "
            class="center"
          >
            <i class="el-icon-search"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="industry-list w1200">
      <div
        class="industry-list-item"
        v-for="(item, index) in industry"
        :key="index"
        :class="{ active: activeIndustryFilter === item }"
        @click="activeIndustryFilter = item"
      >
        {{ item }}
      </div>
    </div>

    <div class="template-industry-list w1200">
      <div v-for="(item, index) in filterList" :key="index">
        <div class="between">
          <span style="font-size: 24px; color: #1d2129; line-height: 24px">{{
            item.title
          }}</span>
          <span style="font-size: 16px; color: #2e98fe; line-height: 20px"
            >查看全部</span
          >
        </div>
        <div class="between" style="margin-top: 20px; margin-bottom: 40px">
          <div
            v-for="info in 4"
            :key="info"
            style="
              width: 284px;
              height: 312px;
              border-radius: 8px 8px 8px 8px;
              border: 1px solid #e9e9e9;
            "
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SiteTemplate",
  data() {
    return {
      hotList: [
        {
          title: "CRM",
          desc: "销售/商机/客户",
          img: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/CRM@2x-090813816.png",
        },
        {
          title: "进销存管理",
          desc: "采购/销售/库存",
          img: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/进销存管理@2x-090813816.png",
        },
        {
          title: "ERP",
          desc: "销售/采购/生产",
          img: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/ERP@2x-090813812.png",
        },
        {
          title: "人事管理",
          desc: "招聘/入转调离",
          img: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/人事管理@2x-090813808.png",
        },
        {
          title: "WMS",
          desc: "来料/栋配/库存",
          img: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/WMS@2x-090813812.png",
        },
      ],
      filterList: [
        {
          title: "CRM/销售",
          list: [],
        },
        {
          title: "ERP/生产",
          list: [],
        },
        {
          title: "进销存/仓库",
          list: [],
        },
        {
          title: "人事/行政",
          list: [],
        },
        {
          title: "项目/任务",
          list: [],
        },
        {
          title: "财务/报销",
          list: [],
        },
        {
          title: "工单/售后",
          list: [],
        },
        {
          title: "采招/供应",
          list: [],
        },
      ],
      activeFilter: "全部场景",
      searchValue: "",
      industry: [
        "全部行业",
        "制造业",
        "互联网/IT",
        "房地产",
        "教育培训",
        "金融",
        "医疗健康",
        "能源",
        "物流",
        "政府",
        "其他",
      ],
      activeIndustryFilter: "全部行业",
    };
  },
  methods: {},
  mounted() {},
};
</script>

<style scoped lang="less">
.template-item {
  height: 478px;
  position: relative;
  img {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    object-fit: cover; /* 让图像覆盖整个容器 */
    z-index: -1;
  }
  .w1200 {
    padding-top: 115px;
  }
}

.template-list {
  margin-top: 18px;
}

.template-list-item {
  width: 227px;
  height: 128px;
  background: linear-gradient(180deg, #edf5ff 0%, #ffffff 100%);
  box-shadow: 2px 2px 14px 0px rgba(55, 99, 170, 0.1);
  border-radius: 8px;
  border: 1px solid;
  border-image: linear-gradient(
      180deg,
      rgba(255, 255, 255, 1),
      rgba(255, 255, 255, 0)
    )
    1 1;
  cursor: pointer;
  padding: 0 20px;
  .template-list-item-title {
    display: flex;
    flex-direction: column;
    gap: 16px;
    span {
      &:nth-child(1) {
        font-weight: 500;
        font-size: 18px;
        color: #1d2129;
        line-height: 20px;
      }
      &:nth-child(2) {
        font-size: 14px;
        color: #636e80;
        line-height: 20px;
      }
    }
  }
  img {
    width: 40px;
    height: 40px;
  }
}

.navs-filter {
  height: 64px;
  background: #f5f7fa;
  .navs-filter-list {
    display: flex;
    align-items: center;
    justify-content: space-between;

    height: 100%;
    .navs-filter-list-item {
      font-size: 16px;
      color: #1d2129;
      line-height: 20px;
      cursor: pointer;
      height: 100%;
      line-height: 64px;
      &.active {
        color: #2e98fe;
        border-bottom: 3px solid #2e98fe;
      }
    }
  }
}

.navs-filter-search {
  width: 200px;
  height: 32px;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #dddddd;
  display: flex;
  align-items: center;
  ::v-deep .el-input__inner {
    border: unset;
    height: 100%;
  }
  .el-icon-search {
    font-size: 12px;
    color: #fff;
  }
  ::v-deep .el-input .el-input__clear {
    line-height: 1;
  }
}

.industry-list {
  padding-top: 24px;
  display: flex;
  gap: 4px;
  margin-bottom: 26px;
  .industry-list-item {
    width: fit-content;
    height: 31px;
    padding: 0 16px;
    background: #ffffff;
    border-radius: 4px;
    font-size: 14px;
    color: #636e80;
    line-height: 31px;
    text-align: center;
    cursor: pointer;
    &.active {
      background: #eaf4ff;
      color: #2e98fe;
    }
  }
}

.hover-btn {
  i {
    transition: all 0.1s ease-in-out;
  }
  &:hover {
    i {
      transform: translateX(10px);
    }
  }
}
</style>